<template>
  <div id="product" class="product-center">
    <div class="product-center-main" :style="{transform: 'scale('+(multiple<1?multiple:1)+', 1)'}">
      <img v-if="isSoft" class="bottom" src="@/assets/img/product/product-center-bg.png" alt="">
      <div v-if="isSoft && active.title" class="img-wrap">
        <img :src="require(`@/assets/img/product/${active.title}.png`)" :class="isBright?' bright':''"  @click="toDetail">
      </div>
      <div class="type-list">
        <div class="type-title">{{ $theme ? '软件中心' : 'Software center' }}</div>
        <div :class="`list${$theme?'':' eng'}`">
          <div v-for="type in soft" :key="'soft'+type.code"
               :class="`type${type.code === activeType.code && isSoft?' active':''}`"
               @click="changeType(type,true)">
            {{ $theme ? type.title : type.titleEng }}
          </div>
        </div>
        <div class="type-title">{{ $theme ? '硬件中心' : 'Hardware center' }}</div>
        <div class="list hard">
          <div v-for="type in hard" :key="'hard'+type.code"
               :class="`type${type.code === activeType.code && !isSoft?' active':''}`"
               @click="changeType(type,false)">
            {{ $theme ? type.title : type.titleEng }}
          </div>
        </div>
      </div>
      <div class="product-list" :style="{paddingTop: hasChild?'10px':'70px'}">
        <template v-if="hasChild">
          <div v-for="product in productList" :key="'hard'+product.code"
          >
            <div class="sub-type">{{ $theme ? product.title : product.titleEng }}</div>
            <div v-for="child in product.children" :key="'child'+child.code"
                 :class="`product${child.code === active.code?' active':''}`" @click="changeProduct(child)">
              <template v-if="$theme">
                <template v-if="child.title.startsWith('汉熵')">
                  <span>汉熵</span>{{ child.title.slice(2) }}
                </template>
                <template v-else>
                  {{ child.title }}
                </template>
              </template>
              <template v-else>
                <template v-if="child.titleEng.startsWith('China Entropy')">
                  <span>China Entropy</span>{{ child.titleEng.slice(13) }}
                </template>
                <template v-else>
                  {{ child.titleEng }}
                </template>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="product in productList" :key="'hard'+product.code"
               :class="`product${product.code === active.code?' active':''}`" @click="changeProduct(product)">
            <template v-if="$theme">
              <template v-if="product.title.startsWith('汉熵')">
                <span>汉熵</span>{{ product.title.slice(2) }}
              </template>
              <template v-else>
                {{ product.title }}
              </template>
            </template>
            <template v-else>
              <template v-if="product.titleEng.startsWith('China Entropy')">
                <span>China Entropy</span>{{ product.titleEng.slice(13) }}
              </template>
              <template v-else>
                {{ product.titleEng }}
              </template>
            </template>
          </div>
        </template>
      </div>
      <div :class="`right ${isSoft?'soft':'hard'}`">
        <div class="title">{{ $theme ? active.title : active.titleEng }}</div>
        <div v-if="!isSoft && $theme" class="back-text">{{ $theme ? active.title : active.titleEng }}</div>
        <div class="intro">{{ $theme ? active.introduction : active.introductionEng }}</div>
        <div class="more" @click="toDetail">
          <div class="quan">
            <div class="con">
              <i class="el-icon-right"></i>
              <i class="el-icon-right"></i>
            </div>
          </div>
          {{ $theme ? '了解更多' : 'Learn more' }}
        </div>
        <div v-if="!isSoft" ref="viewer" id="viewer" class="viewer" @mousemove="onMousemove" @mouseleave="onMouseleave">
          <div class="circle" :style="{top: top+'px',left: left+'px'}"></div>
        </div>
      </div>
    </div>
    <ModelSix @toTop="backToTop"></ModelSix>
    <transition-group name="slide-fade">
      <Soft v-if="softDetailVisible" key="1" :obj="obj" @close="softDetailVisible=false;obj=null"></Soft>
      <Hard v-if="hardDetailVisible" key="2" :obj="obj" @close="hardDetailVisible=false;obj=null"></Hard>
    </transition-group>
  </div>
</template>

<script>
import * as THREE from "three"
// import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import {GLTFLoader} from 'three/examples/jsm//loaders/GLTFLoader.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import ModelSix from "@/views/home/components/model-six/Index.vue";
import {getHardwareTree, getSoftwareTree} from "@/api/product";
import Soft from "../product-detail/soft/Index.vue"
import Hard from "../product-detail/hard/Index.vue"
import map from "./model.js";

export default {
  name: "ProductCenter",
  components: {
    ModelSix,
    Soft,
    Hard
  },
  data() {
    return {
      showHeader: true,
      activeType: {},
      active: {},
      isSoft: true,
      soft: [],
      hard: [],
      top: -80,
      left: -80,
      productList: [],
      hasChild: false,
      obj: null,
      hardDetailVisible: false,
      softDetailVisible: false,
      initialPosition: '',
      initialQuaternion: '',
      map,
      multiple: 1,
      bright: ['群防群治管理平台', '大气环境监测预警平台', '水环境监测预警平台', '危固废动态管理平台', '智慧应急综合预警研判系统', '公安警情大数据智能研判作战平台', '安防小区管控平台']
    };
  },
  // hardwareList() {
  //   return this.$store.getters.hardwareList
  // },
  // softwareList() {
  //   return this.$store.getters.softwareList
  // },
  watch: {
    showHeader(val) {
      this.$bus.$emit("change-show-header", val);
    },
  },
  created() {
  },
  async mounted() {
    window.addEventListener('scroll', this.getScroll, true);
    window.addEventListener('resize', this.onWindowResize, false)
    this.$nextTick(() => {
      this.onWindowResize()
    })
    const {data} = await getSoftwareTree()
    this.soft = data
    this.changeType(data[0], true)
    const {data: hard} = await getHardwareTree()
    this.hard = hard
    // console.log('soft', data)
    // console.log('hard', hard)
    // sessionStorage.setItem("soft", JSON.stringify(data))
    // sessionStorage.setItem("hard", JSON.stringify(hard))
  },
  computed: {
    isBright() {
      if (!this.active?.title) return false
      return !this.bright.includes(this.active.title)
    }
  },
  methods: {
    onWindowResize() {
      const width = document.body.clientWidth;
      this.multiple = width / 1920
      if (!this.scene) {
        return
      }
      const viewer = this.$refs.viewer
      this.renderer.setSize(viewer.clientWidth, viewer.clientHeight)
      this.camera.aspect = viewer.clientWidth / viewer.clientHeight
      this.camera.updateProjectionMatrix()
    },
    changeType(type, bool) {
      let temp = true
      if (this.isSoft && !bool) {
        this.isSoft = bool
        temp = false
        this.$nextTick(() => {
          this.initScene()
        })
      } else {
        this.isSoft = bool
      }
      this.activeType = type;
      this.productList = type.children
      this.hasChild = !!(type.children[0].children)
      this.changeProduct(this.hasChild ? this.productList[0].children[0] : this.productList[0], temp)
    },
    changeProduct(product, temp = true) {
      this.active = product
      if (this.isSoft) {
        return
      }
      if (temp) {
        this.addModel()
      }
    },
    initScene() {
      // 初始化场景
      const viewer = this.$refs.viewer
      const scene = new THREE.Scene();
      const light = new THREE.AmbientLight(0xffffff, 1);
      scene.add(light);
      const sunlight = new THREE.DirectionalLight(0xffffff, this.map[this.active.title]?.intensity || 1.5);
      const position = this.map[this.active.title]?.position || [-20, 5, 5]
      sunlight.position.set(position[0], position[1], position[2]);
      // sunlight.target.set(0, -15, 0);
      scene.add(sunlight);
      this.sunlight = sunlight
      // const helper = new THREE.DirectionalLightHelper(sunlight, 15);
      // scene.add(helper);
      const camera = new THREE.PerspectiveCamera(75, viewer.clientWidth / viewer.clientHeight, 0.1, 10000);
      camera.position.set(0, 0, 50);

      const renderer = new THREE.WebGLRenderer();
      // renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setSize(viewer.clientWidth, viewer.clientHeight);
      renderer.setClearColor(0x0a0a0a, 0);
      renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer = renderer
      viewer.appendChild(renderer.domElement);

      // const axes = new THREE.AxesHelper(50);
      // scene.add(axes);
      const controls = new OrbitControls(camera, renderer.domElement);
      // controls.enableDamping = true
      // controls.dampingFactor = 0.2
      // controls.minPolarAngle = (Math.PI) / 180
      // controls.maxPolarAngle = (Math.PI * 70) / 180
      controls.enablePan = false
      controls.enableZoom = false

      function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
        controls.update();
      }

      animate();
      // const geometry = new THREE.BoxGeometry(10, 10, 10);
      // const material = new THREE.MeshBasicMaterial({color: 0xffff00});
      // const mesh = new THREE.Mesh(geometry, material);
      // scene.add(mesh);
      this.scene = scene
      this.camera = camera
      this.initialPosition = camera.position.clone();
      this.initialQuaternion = camera.quaternion.clone();
      this.addModel()
    },
    addModel() {
      const position = this.map[this.active.title]?.position || [-50, 50, 20]
      this.sunlight.position.set(position[0], position[1], position[2]);
      const {scene, camera} = this
      camera.position.copy(this.initialPosition);
      camera.quaternion.copy(this.initialQuaternion);
      if (this.model) {
        scene.remove(this.model)
      }
      const loader = new GLTFLoader();
      loader.load(
          `/model/product/${this.active.title}.glb`,
          (gltf) => {
            const model = gltf.scene
            const y = this.map[this.active.title]?.y || -15
            const scale = this.map[this.active.title]?.scale || 50
            const rotation = this.map[this.active.title]?.rotation || [0, -Math.PI / 6, 0]
            model.scale.set(scale, scale, scale)
            model.rotation.set(rotation[0], rotation[1], rotation[2])
            model.position.set(0, y, 0)
            // 递归遍历所有模型节点批量修改材质
            model.traverse((obj) => {
              if (obj.isMesh) { // 判断是否是网格模型
                obj.material.metalness = this.map[this.active.title]?.metalness || 0.5
              }
            });
            scene.add(model)
            this.model = model
          }
      );
    },
    toDetail() {
      // const list = this.isSoft ?this.soft:this.hard
      this.obj = {
        ...JSON.parse(JSON.stringify(this.active)),
        parentName: this.activeType.title,
        parentNameEng: this.activeType.titleEng
      }
      if (this.isSoft) {
        this.softDetailVisible = true
      } else {
        this.hardDetailVisible = true
      }
    },
    onMousemove(e) {
      this.left = e.offsetX
      this.top = e.offsetY
    },
    onMouseleave() {
      this.top = -80
      this.left = -80
    },
    getScroll() {
      const element = document.getElementById("product");
      if(!element) return
      let scrollTop_ = element.scrollTop;
      this.showHeader = scrollTop_ < 50

      // var scrollHeight = element.scrollHeight;
      // var clientHeight = element.clientHeight;
      //
      // if (scrollTop_ + clientHeight >= scrollHeight) {
      //   // 页面已滚动到底部
      //   this.showHeader = false;
      // } else {
      //   this.showHeader = true;
      // }
    },
    backToTop() {
      document.getElementById('product').scrollTo({left: 0, top: 0, behavior: 'smooth'})
    },
  },
  beforeDestroy() {
    if (this.model) {
      this.scene.remove(this.model)
    }
    this.model = null
    this.scene = null
  },
  destroyed() {
    window.removeEventListener('scroll', this.getScroll);
  },
};
</script>
<style lang="scss" scoped>
@import "./Index.scss";
</style>
